import { render, staticRenderFns } from "./Faixas.vue?vue&type=template&id=8fc62b4a&"
import script from "./Faixas.vue?vue&type=script&lang=js&"
export * from "./Faixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports